var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.report.title != '결과물 더 보기')?_c('div',{staticClass:"mb-2"},[_c('router-link',{attrs:{"to":{
        name: 'reportShow',
        params: { title: _vm.report.title, target: '_blank' }
      }}},[_vm._v(_vm._s(_vm.report.title))])],1):_c('div',[_c('router-link',{attrs:{"to":{ name: 'portfolio' }}},[_vm._v(_vm._s(_vm.report.title))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }